import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { EnvelopeComponent } from './envelope.component';
import { SignatoryComponent } from './signatory/signatory.component';
import { ReviewComponent } from './review/review.component';
import { SignatoryOrderComponent } from './signatory-order/signatory-order.component';
import { EnvelopeSettingsComponent } from './envelope-settings/envelope-settings.component';
import './extension/array.extension';
import { GeneralInformationComponent } from './review/general-information/general-information.component';
import { SignatoryInformationComponent } from './review/signatory-information/signatory-information.component';
import { ObserverInformationComponent } from './review/observer-information/observer-information.component';
import { EnvelopeService } from './services/envelope.service';
import { SentListComponent } from './sent/sent-list/sent-list.component';
import { EnvelopeListComponent } from './shared/envelope-list/envelope-list.component';
import { SentTabsComponent } from './sent/sent-tabs/sent-tabs.component';
import { SentComponent } from './sent/sent.component';
import { EnvelopeFilterComponent } from './shared/envelope-filter/envelope-filter.component';
import { EnvelopeGridCardContentComponent } from './shared/envelope-grid-card-content/envelope-grid-card-content.component';
import { EnvelopeListCardContentComponent } from './shared/envelope-list-card-content/envelope-list-card-content.component';
import { SentDetailSidebarComponent } from './sent/sent-detail-sidebar/sent-detail-sidebar.component';
import { SharedModule } from '../modules/shared/shared.module';
import { AuthorizerInformationComponent } from './review/authorizer-information/authorizer-information.component';
import { AuthorizerComponent } from './envelope-authorizer/envelope-authorizer.component';
import { EnvelopeDetailsEditComponent } from './envelope-details-edit/envelope-details-edit.component';
import { EnvelopeEditComponent } from './envelope-edit/envelope-edit.component';
import { EnvelopeSignaturesComponent } from './envelope-signatures/envelope-signatures.component';
import { EnvelopeEditAuthorizersComponent } from './envelope-edit/envelope-edit-authorizers/envelope-edit-authorizers.component';
import { EnvelopeEditSignatoriesComponent } from './envelope-edit/envelope-edit-signatories/envelope-edit-signatories.component';
import { EnvelopeEditInformationComponent } from './envelope-edit/envelope-edit-information/envelope-edit-information.component';
import { EditSignatoriesOrderComponent } from
  './envelope-edit/envelope-edit-signatories/edit-signatories-order/edit-signatories-order.component';
import { EnvelopeDetailsDeleteComponent } from './envelope-details-delete/envelope-details-delete.component';
import { EnvelopeDetailsArchivedComponent } from './envelope-details-archive/envelope-details-archived.component';
import { ObserverComponent } from './envelope-observer/envelope-observer.component';
import { ModalReuseSignaturesComponent } from './envelope-edit/envelope-edit-signatories/modal-reuse-signatures/modal-reuse-signatures.component';
import { EnvelopeResponsibleComponent } from './envelope-responsible/envelope-responsible.component';
import { ResponsibleInformationComponent } from './review/responsible-information/responsible-information.component';

@NgModule({
  declarations: [
    EnvelopeComponent,
    SignatoryComponent,
    ReviewComponent,
    GeneralInformationComponent,
    SignatoryInformationComponent,
    ObserverInformationComponent,
    SignatoryOrderComponent,
    EnvelopeSettingsComponent,
    EnvelopeListComponent,
    EnvelopeFilterComponent,
    SentListComponent,
    SentTabsComponent,
    SentComponent,
    EnvelopeGridCardContentComponent,
    EnvelopeListCardContentComponent,
    SentDetailSidebarComponent,
    AuthorizerInformationComponent,
    AuthorizerComponent,
    EnvelopeEditComponent,
    EnvelopeSignaturesComponent,
    EnvelopeDetailsEditComponent,
    EnvelopeDetailsDeleteComponent,
    EnvelopeEditAuthorizersComponent,
    EnvelopeEditSignatoriesComponent,
    EnvelopeEditInformationComponent,
    EditSignatoriesOrderComponent,
    EnvelopeDetailsArchivedComponent,
    ModalReuseSignaturesComponent,
    ObserverComponent,
    EnvelopeResponsibleComponent,
    ResponsibleInformationComponent,
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [TitleCasePipe, EnvelopeService],
  exports: [
    EnvelopeComponent,
    SignatoryComponent,
    ReviewComponent,
    EnvelopeSettingsComponent,
    EnvelopeSignaturesComponent,
    SentComponent
  ]
})
export class EnvelopeModule { }
